<template>
  <b-container>
    <div class="row col-3">
      <h5 class="text-azul">ICONOGRAFÍA</h5>
    </div>
    <div class="container iconos d-md-flex mb-4 pt-3 col-12 mx-auto">
      <div class="row col-md-3">
        <table class="table table-borderless table-sm">
          <tbody>
            <!--<tr>
              <th scope="col">
                <img src="@/assets/img/iconos/acreditacion-8.svg" class="small-ic mr-3" />
              </th>
              <td scope="col">Años de Acreditación Institucional</td>
            </tr>-->
            <tr>
              <th scope="col">
                <img src="@/assets/img/iconos/gratuidad-4.svg" class="small-ic mr-3" />
              </th>
              <td scope="col">Adscrita a Gratuidad</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </b-container>
</template>

<script>
export default {};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/buscadorInstU/Iconografia.vue